module.exports = __webpack_public_path__ + "32bf6bfdcd46e3c75c547b35071c0444.svg";